import * as React from 'react';

import AuthCode from 'react-auth-code-input';

import { RefreshIcon } from '@icons';

import { useMutationTwoFaLogin } from '@hooks/api/auth/use-mutation-two-fa-login';
import { useTwoFaAuthorization } from '@hooks/api/auth/use-two-fa-authorization';

import { Button } from '@components/button';
import { Modal } from '@components/modal';

import * as Styled from './two-fa-modal.styled.ts';

type OwnProps = {
	isOpen: boolean;
	closeModal: () => void;
	twoFASessionKey: string | null;
	id: string;
	password: string;
	closeAuthModal: () => void;
};

const TwoFaModal: React.FC<OwnProps> = ({ isOpen, closeModal, twoFASessionKey, id, password, closeAuthModal }) => {
	const handleCloseModal = () => {
		closeModal();
	};

	const [freshTwoFaSessionKey, setFreshTwoFasessionKey] = React.useState<string | null>(twoFASessionKey);

	const { mutate: twoFaAuthorization, isPending: isTwoFaAuthorizationPending } = useTwoFaAuthorization(true);

	const [code, setCode] = React.useState<string>('');

	const [error, setError] = React.useState<{ general: string } | null>(null);

	const handleOnChange = (res: string) => {
		setCode(res);
	};

	const handleSubmit = () => {
		twoFaAuthorization(
			{ code, twoFASessionKey: freshTwoFaSessionKey },
			{
				onSuccess: () => {
					closeModal();
					closeAuthModal();
				},
				onError: () => {
					setError({
						general: 'Указанный код неправильный или просрочен'
					});
				}
			}
		);
	};
	const { mutate: twoFaLogin, isPending: isTwoFaLoginPending } = useMutationTwoFaLogin();

	const handleGetNewCode = () => {
		twoFaLogin(
			{ id, password },
			{
				onSuccess: data => {
					setFreshTwoFasessionKey(data.twoFASessionKey);
				}
			}
		);
	};

	React.useEffect(() => {
		if (!code) {
			setError(null);
		}
	}, [code]);

	return (
		<Modal isOpen={isOpen} closeModal={handleCloseModal} maxWidth={500} size='large' hasPadding={false}>
			<Styled.Wrapper>
				<Styled.Header>Код авторизации</Styled.Header>
				<Styled.Body>
					<Styled.Info>На ваш номер был отправлен код</Styled.Info>
					<Styled.InputWrapper errors={Boolean(error?.general)}>
						<AuthCode onChange={handleOnChange} />
					</Styled.InputWrapper>
					{error && <Styled.Error>{error.general}</Styled.Error>}
					<Styled.NewCodeWrapper
						onClick={isTwoFaLoginPending ? undefined : handleGetNewCode}
						isTwoFaLoginPending={isTwoFaLoginPending}
					>
						<RefreshIcon />
						Получить новый код
					</Styled.NewCodeWrapper>
					<Styled.ButtonWrapper>
						<Button
							fluid
							color='primary'
							disabled={code.length !== 6 || isTwoFaAuthorizationPending}
							onClick={handleSubmit}
						>
							Подтвердить
						</Button>
					</Styled.ButtonWrapper>
				</Styled.Body>
			</Styled.Wrapper>
		</Modal>
	);
};

export default TwoFaModal;
